import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  template: `
    @if (fullPage()) {
      <div class="min-h-screen flex items-center justify-center bg-[#faf6ed]">
        <span [class]="classes()" role="status" aria-label="Loading"></span>
      </div>
    } @else {
      <span [class]="classes()" aria-hidden="true"></span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  size = input<'sm' | 'md'>('md');
  fullPage = input(false);

  protected readonly classes = computed(() => {
    const base = 'inline-block rounded-full animate-spin border-solid';
    return this.size() === 'sm'
      ? `${base} w-4 h-4 border-2 border-[#26332b]/30 border-t-[#26332b]`
      : `${base} w-10 h-10 border-4 border-[#26332b]/20 border-t-[#4d806f]`;
  });
}
